export const registerData = {
  id: "66669651",
  tenantId: "54",
  schemaId: "66669509",
  title: "新建注册表单(9)",
  createTime: "2020-07-10 09:23:50",
  updateTime: "2021-09-15 18:42:09",
  memberIsEnabled: "1",
  pcUrl: "https://dev.uao.so/dpm66669651c2486",
  wapUrl: "https://dev.uao.so/dwm66669651c2487",
  pcPreviewUrl: "https://dev.uao.so/dpm66669651c2486p",
  wapPreviewUrl: "https://dev.uao.so/dwm66669651c2487p",
  deleted: "0",
  isBind: "1",
  memberNum: "17",
  isSmsCodeLogin: "1",
  defaultLoginType: "1",
  isEnableWechat: 0,
  isEnableQQ: "1",
  pcConfigId: "2486",
  wapConfigId: "2487",
  pcSourceUrl:
    "https://devf.smarket.net.cn/smarket/template/078f097e0e29d7e56d5ad4a84a085df4/view/login.html?memberId=66669651&memberFormId=66669651&trackId=0&memberSchemaId=66669509&configId=2486",
  wapSourceUrl:
    "https://devf.smarket.net.cn/smarket/template/40d26de9620a7dcaa5925e669813fbb8/view/login.html?memberId=66669651&memberFormId=66669651&trackId=0&memberSchemaId=66669509&configId=2487",
  isEnableSignup: "1",
  isNormal: "1",
  authWeChatId: "0",
  canShare: "1",
  shareTitle: null,
  shareDesc: null,
  sharePic: null,
  templateVersion: "0",
  originUrl: {
    pc: "https://devf.smarket.net.cn/smarket/template/078f097e0e29d7e56d5ad4a84a085df4/view/login.html?memberId=66669651&memberFormId=66669651&trackId=0&memberSchemaId=66669509&configId=2486",
    wap: "https://devf.smarket.net.cn/smarket/template/40d26de9620a7dcaa5925e669813fbb8/view/login.html?memberId=66669651&memberFormId=66669651&trackId=0&memberSchemaId=66669509&configId=2487",
  },
  registerUrl: {
    pc: "https://devf.smarket.net.cn/smarket/template/078f097e0e29d7e56d5ad4a84a085df4/view/register.html?memberId=66669651&memberFormId=66669651&trackId=0&memberSchemaId=66669509&configId=2486",
    wap: "https://devf.smarket.net.cn/smarket/template/40d26de9620a7dcaa5925e669813fbb8/view/register.html?memberId=66669651&memberFormId=66669651&trackId=0&memberSchemaId=66669509&configId=2487",
  },
  items: [
    {
      id: "4787",
      tenantId: "54",
      schemaId: "66669509",
      formId: "66669651",
      fieldName: "name",
      displayName: "姓名",
      fieldType: "TEXT",
      fileLimitType: "",
      textLimitType: "UNCHECK",
      textRegularExpression: "",
      textLength: "0",
      textRegularId: "0",
      listOptionType: "",
      listDictId: "0",
      listLimitType: "",
      maxOptionId: "0",
      dateLimitType: "",
      orderId: "1",
      deleted: "0",
      isSystemed: "1",
      isShow: "0",
      required: "1",
      enabled: "1",
      errorMessage: "",
      isOverWrite: "1",
      isRecordHistory: "1",
      isExport: "1",
      memberFieldName: "mbr_member.realname",
      identFieldName: "mbr_identification.realname",
      displayType: "1",
      isLogin: "0",
      versionNumber: "7",
      isSendSms: "0",
      isFormed: "1",
      fieldId: "5000",
      aliasName: "",
      privacyPolicyGloble: "1",
      privacyPolicyUrl: null,
      privacyPolicyTitle: null,
      privacyPolicyUrlTitle: null,
      isSelected: null,
      regularExpression: "",
      regularDesc: "",
      regularName: "",
      schemaRequired: "1",
      schemaErrorMessage: 0,
      schemaTextLimitType: "UNCHECK",
    },
    {
      id: "4788",
      tenantId: "54",
      schemaId: "66669509",
      formId: "66669651",
      fieldName: "mobile",
      displayName: "手机",
      fieldType: "TEXT",
      fileLimitType: "",
      textLimitType: "SYSTEM",
      textRegularExpression: "^(?!(0|86))\\d+$",
      textLength: "11",
      textRegularId: "17",
      listOptionType: "",
      listDictId: "0",
      listLimitType: "",
      maxOptionId: "0",
      dateLimitType: "",
      orderId: "2",
      deleted: "0",
      isSystemed: "1",
      isShow: "0",
      required: "1",
      enabled: "1",
      errorMessage: "",
      isOverWrite: "1",
      isRecordHistory: "1",
      isExport: "1",
      memberFieldName: "mbr_member.mobile",
      identFieldName: "mbr_identification.mobile",
      displayType: "1",
      isLogin: "1",
      versionNumber: "5",
      isSendSms: "0",
      isFormed: "1",
      fieldId: "5001",
      aliasName: "",
      privacyPolicyGloble: "1",
      privacyPolicyUrl: null,
      privacyPolicyTitle: null,
      privacyPolicyUrlTitle: null,
      isSelected: null,
      regularExpression: "^(?!(0|86))\\d+$",
      regularDesc: "国际手机号",
      regularName: "INTMobile",
      schemaRequired: "0",
      schemaErrorMessage: 0,
      schemaTextLimitType: "SYSTEM",
      schemaTextLength: "11",
    },
    {
      id: "4789",
      tenantId: "54",
      schemaId: "66669509",
      formId: "66669651",
      fieldName: "email",
      displayName: "邮箱",
      fieldType: "TEXT",
      fileLimitType: "",
      textLimitType: "SYSTEM",
      textRegularExpression: "^(\\w)+(.|-\\w+)*@(.|-|\\w)+((\\.\\w+)+)$",
      textLength: "0",
      textRegularId: "11",
      listOptionType: "",
      listDictId: "0",
      listLimitType: "",
      maxOptionId: "0",
      dateLimitType: "",
      orderId: "3",
      deleted: "0",
      isSystemed: "1",
      isShow: "0",
      required: "0",
      enabled: "1",
      errorMessage: "",
      isOverWrite: "1",
      isRecordHistory: "1",
      isExport: "1",
      memberFieldName: "mbr_member.email",
      identFieldName: "mbr_identification.email",
      displayType: "1",
      isLogin: "1",
      versionNumber: "3",
      isSendSms: "0",
      isFormed: "1",
      fieldId: "5002",
      aliasName: "",
      privacyPolicyGloble: "1",
      privacyPolicyUrl: null,
      privacyPolicyTitle: null,
      privacyPolicyUrlTitle: null,
      isSelected: null,
      regularExpression: "^(\\w)+(.|-\\w+)*@(.|-|\\w)+((\\.\\w+)+)$",
      regularDesc: "邮箱格式",
      regularName: "email",
      schemaRequired: "0",
      schemaErrorMessage: 0,
      schemaTextLimitType: "SYSTEM",
      schemaTextLength: 0,
    },
    {
      id: "4794",
      tenantId: "54",
      schemaId: "66669509",
      formId: "66669651",
      fieldName: "enterprise",
      displayName: "公司",
      fieldType: "TEXT",
      fileLimitType: "",
      textLimitType: "UNCHECK",
      textRegularExpression: "",
      textLength: "0",
      textRegularId: "0",
      listOptionType: "",
      listDictId: "0",
      listLimitType: "",
      maxOptionId: "0",
      dateLimitType: "",
      orderId: "11",
      deleted: "0",
      isSystemed: "1",
      isShow: "0",
      required: "0",
      enabled: "1",
      errorMessage: "",
      isOverWrite: "1",
      isRecordHistory: "1",
      isExport: "1",
      memberFieldName: "mbr_member.company",
      identFieldName: "mbr_identification.company",
      displayType: "1",
      isLogin: "0",
      versionNumber: "3",
      isSendSms: "0",
      isFormed: "1",
      fieldId: "5010",
      aliasName: "",
      privacyPolicyGloble: "1",
      privacyPolicyUrl: null,
      privacyPolicyTitle: null,
      privacyPolicyUrlTitle: null,
      isSelected: null,
      regularExpression: "",
      regularDesc: "",
      regularName: "",
      schemaRequired: "0",
      schemaErrorMessage: 0,
      schemaTextLimitType: "UNCHECK",
    },
  ],
  values: [],
  oauthInfo: {
    qq: {
      loginUrl: "https://dev-wxoauthb.smarket.net.cn/oauth/qq/login",
      callbackUrl: "https://dev-wxoauthb.smarket.net.cn/oauth/qq/callback",
      accountType: -1,
      isCertified: -1,
    },
  },
  type: ["normal", "third", "checkcode"],
};
